import Breadcrumb, { BreadcrumbLink } from "components/common/Breadcrumb";
import { DangerAlert } from "components/common/Alerts";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import downloadResponse from "utils/downloadResponse";
import extractErrorMessage from "utils/extractErrorMessage";

interface State {
    errorMessage?: string;
}

export default class Index extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            errorMessage: undefined,
        };

        this.handleCustomerReportClicked =
            this.handleCustomerReportClicked.bind(this);
        this.handleJobReportClicked = this.handleJobReportClicked.bind(this);
        this.handleVendorReportClicked = this.handleVendorReportClicked.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Reports</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <div className=" button-group button-group--main">
                        <Link
                            to="/reports/customers"
                            className="button__item"
                            onClick={this.handleCustomerReportClicked}
                        >
                            <i className="icon-customers-black"></i>Customer Catalog
                        </Link>
                        <Link to="/reports/products" className="button__item">
                            <i className="icon-products-black"></i>Item Catalog
                        </Link>
                        <Link
                            to="/reports/jobs"
                            className="button__item"
                            onClick={this.handleJobReportClicked}
                        >
                            <i className="icon-jobs"></i>Project Catalog
                        </Link>
                        <Link
                            to="/reports/vendor"
                            className="button__item"
                            onClick={this.handleVendorReportClicked}
                        >
                            <i className="icon-dashboard-black"></i>Vendor Catalog
                        </Link>
                        <Link to="/reports/quotes" className="button__item">
                            <i className="icon-reports-black"></i>Quotes
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        document.title = "Reports - " + SITE_NAME;
    }

    private async handleCustomerReportClicked(
        event: React.MouseEvent<HTMLAnchorElement>
    ) {
        event.preventDefault();

        this.setState({ errorMessage: undefined });
        let response = await apifetch("reports/customers", undefined, true);
        if (response.ok) {
            downloadResponse(response);
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    private async handleJobReportClicked(
        event: React.MouseEvent<HTMLAnchorElement>
    ) {
        event.preventDefault();

        this.setState({ errorMessage: undefined });
        let response = await apifetch("reports/jobs", undefined, true);
        if (response.ok) {
            downloadResponse(response);
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    private async handleVendorReportClicked(
        event: React.MouseEvent<HTMLAnchorElement>
    ) {
        event.preventDefault();

        this.setState({ errorMessage: undefined });
        let response = await apifetch("reports/vendors", undefined, true);
        if (response.ok) {
            downloadResponse(response);
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/reports/Index.tsx